<ng-container *ngFor="let data of dataSources; let i = index">

  <table mat-table multiTemplateDataRows [dataSource]="data" class="mat-elevation-z4">

    <ng-container matColumnDef="zeitspanne">
      <th mat-header-cell *matHeaderCellDef>{{data.data[0].gueltigVonLokaleZeit | date: 'EEE dd.MM'}}</th>
      <td mat-cell *matCellDef="let element">{{element?.gueltigVonLokaleZeit | date: 'HH:mm'}}
        - {{element?.gueltigBisLokaleZeit | date: 'HH:mm'}}</td>
    </ng-container>

    <ng-container matColumnDef="wettersymbol">
      <th mat-header-cell *matHeaderCellDef>
        <mat-icon>cloud_queue</mat-icon>
      </th>
      <td mat-cell *matCellDef="let element"><img class="vorhersage-table-wettersymbol"
                                                  src="{{datastoreService.getWetterSymbolUrl(element?.wettersymbol?.wert)}}">
      </td>
    </ng-container>

    <ng-container matColumnDef="temperaturMin">
      <th mat-header-cell *matHeaderCellDef>
        <mat-icon svgIcon="thermometer_min"></mat-icon>
      </th>
      <td mat-cell
          *matCellDef="let element">{{werteConverter.convertDecimalWithComma(element?.luftTemperaturMinimum.wert)}} {{element?.luftTemperaturMinimum.einheit}}</td>
    </ng-container>

    <ng-container matColumnDef="temperaturMax">
      <th mat-header-cell *matHeaderCellDef>
        <mat-icon svgIcon="thermometer_max" style="color: orange"></mat-icon>
      </th>
      <td mat-cell
          *matCellDef="let element">{{werteConverter.convertDecimalWithComma(element?.luftTemperaturMaximum.wert)}} {{element?.luftTemperaturMaximum.einheit}}</td>
    </ng-container>

    <ng-container matColumnDef="niederschlag">
      <th mat-header-cell *matHeaderCellDef>
        <mat-icon>umbrella</mat-icon>
      </th>
      <td mat-cell
          *matCellDef="let element">{{element?.niederschlagsWahrscheinlichkeit.wert}} {{element?.niederschlagsWahrscheinlichkeit.einheit}}</td>
    </ng-container>

    <ng-container matColumnDef="windrichtung">
      <th mat-header-cell *matHeaderCellDef>
        <mat-icon>air</mat-icon>
      </th>
      <td mat-cell
          *matCellDef="let element">
        <mat-icon
          matTooltip="{{element?.windRichtung.wert +  element?.windRichtung.einheit}}"
          class="mat_icon_subtitle">{{werteConverter.getWindrichtungsIconByText(element?.windRichtung.text)}}</mat-icon>
        <mat-label class="table-icon-label">{{element?.windRichtung.text}}</mat-label>
      </td>
    </ng-container>

    <ng-container matColumnDef="windgeschwindigkeit">
      <th mat-header-cell *matHeaderCellDef>
        <mat-icon>speed</mat-icon>
      </th>
      <td mat-cell
          *matCellDef="let element">{{element?.mittlereWindGeschwindigkeit.wert | number :'1.0-0':'de'}} {{element?.mittlereWindGeschwindigkeit.einheit}}</td>
    </ng-container>

    <ng-container matColumnDef="accordionExpansion">
      <th mat-header-cell *matHeaderCellDef></th>
      <td *matCellDef="let element" mat-cell>
        <mat-icon *ngIf="element !== expandedElement">keyboard_arrow_down</mat-icon>
        <mat-icon *ngIf="element === expandedElement">keyboard_arrow_up</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
        <div class="vorhersage-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <app-3h-vorhersage-table-detail [messwerte]="element"></app-3h-vorhersage-table-detail>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;"
        class="vorhersage-element-row"
        [class.vorhersage-expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element"></tr>
    <tr mat-row *matRowDef="let element; columns: ['expandedDetail']" class="expanded-vorhersage-detail-row"></tr>

  </table>
</ng-container>
